namespace AgerLMS.LMS {
    export interface LiveBroadcastRow {
        Id?: number;
        LiveBroadcastType?: LiveBroadcastTypes;
        Title?: string;
        Description?: string;
        LiveBroadcastLink?: string;
        CategoryId?: number;
        PriceCategory?: PriceCategory;
        Price?: number;
        EnableOrdering?: boolean;
        Thumbnail?: string;
        CoverImage?: string;
        DemoVideo?: string;
        PlannedStartDate?: string;
        PlannedEndDate?: string;
        DisplayOrder?: number;
        Seo?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace LiveBroadcastRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'LMS.LiveBroadcast';
        export const deletePermission = 'LMS:LiveBroadcast:Modify';
        export const insertPermission = 'LMS:LiveBroadcast:Modify';
        export const readPermission = 'LMS:LiveBroadcast:Read';
        export const updatePermission = 'LMS:LiveBroadcast:Modify';

        export declare const enum Fields {
            Id = "Id",
            LiveBroadcastType = "LiveBroadcastType",
            Title = "Title",
            Description = "Description",
            LiveBroadcastLink = "LiveBroadcastLink",
            CategoryId = "CategoryId",
            PriceCategory = "PriceCategory",
            Price = "Price",
            EnableOrdering = "EnableOrdering",
            Thumbnail = "Thumbnail",
            CoverImage = "CoverImage",
            DemoVideo = "DemoVideo",
            PlannedStartDate = "PlannedStartDate",
            PlannedEndDate = "PlannedEndDate",
            DisplayOrder = "DisplayOrder",
            Seo = "Seo",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
